import { render, staticRenderFns } from "./ImgSwiperV3.vue?vue&type=template&id=039f8cd1&scoped=true&"
import script from "./ImgSwiperV3.vue?vue&type=script&lang=js&"
export * from "./ImgSwiperV3.vue?vue&type=script&lang=js&"
import style0 from "./ImgSwiperV3.vue?vue&type=style&index=0&id=039f8cd1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039f8cd1",
  null
  
)

export default component.exports